module.exports = __webpack_public_path__ + "img/b3dec4b239443777e6005568ad412749.png";


//////////////////
// WEBPACK FOOTER
// ./classes/heroes/seb/assets/sprites/seb_05.png
// module id = 62
// module chunks = 0